import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatchService } from '../match.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from '../user.service';

@Component({
  selector: 'app-match-activities',
  templateUrl: './match-activities.component.html',
  styleUrls: ['./match-activities.component.css']
})
export class MatchActivitiesComponent implements OnInit, OnDestroy {
  matchActivities: any;
  isLoading = false;
  id: any;
  level = '0';
  private activitiesSub: Subscription;
  constructor(private matchService: MatchService, private route: ActivatedRoute, private userService: UserService) { }

  ngOnInit() {
    this.isLoading = true;
    this.level = this.userService.getUserLevel();
    this.route.paramMap.subscribe((paramMap: ParamMap) => {     
      if (paramMap.has('id')) {
        this.id = paramMap.get('id');
        this.matchService.getMatchActivities(this.id);
        this.activitiesSub = this.matchService.getUpdateMatchActivitiesListner()
        .subscribe((response) => {
          this.isLoading = false;
          //console.log(response);
          this.matchActivities = response.matchActivities;
          //console.log(this.matchActivities);
        },
        error => {
          console.log(error);
        });
      } 
   });
  }

  ngOnDestroy() {
    this.activitiesSub.unsubscribe();
  }
}